const guiColors = {
    // Teintes basées sur le rose (Primaire)
    'motion-primary': '#D60270',
    'motion-primary-transparent': '#D60270e6',
    'motion-tertiary': '#96014e',

    // Teintes mélangées/violettes (Secondaire)
    'looks-secondary': '#9B4F96',
    'looks-transparent': '#9B4F9659',
    'looks-light-transparent': '#9B4F9626',
    'looks-secondary-dark': 'hsla(294, 33%, 30%, 1)',

    // Teintes basées sur le bleu (Extensions)
    'extensions-primary': 'hsla(220, 100%, 33%, 1)',
    'extensions-tertiary': 'hsla(220, 100%, 20%, 1)',
    'extensions-transparent': 'hsla(220, 100%, 33%, 0.35)',
    'extensions-light': 'hsla(220, 50%, 85%, 1)',

    'drop-highlight': '#ff7ac2',

    // Dégradé intégrant les couleurs du drapeau bi
    'menu-bar-background-image': 'linear-gradient(90deg, #D60270 0%, #D60270 40%, #9B4F96 45%, #9B4F96 55%, #0038A8 60%, #0038A8 100%)'
};

const blockColors = {
    checkboxActiveBackground: '#D60270',
    checkboxActiveBorder: '#96014e'
};

export {
    guiColors,
    blockColors
};
